import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useState } from "react";
import CommonForm from "../../../components/form/form";
import {
  createCategory,
  deleteCategory,
  getCategoryList,
  updateCategory,
} from "../../../../services/workspace/inventory.service";
import { useNavigate } from "react-router-dom";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
  ADD: "ADD",
};

const items = [{ label: "Manage Category", path: "" }];

const customCases = {
  0: { label: "Disable", color: "text-red-500 text-sm", bg: "bg-red-500" },
  1: { label: "Active", color: "text-green-600 text-sm", bg: "bg-green-600" },
};

const ManageCategory = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const navigate = useNavigate();
  // useEffect(()=>{
  //   console.log(action,'item.....',isSubCategoryModalOpen)
  // },[isSubCategoryModalOpen])
  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getCategoryList, {
    dataPath: "category.data",
    totalPath: "category.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
      only_parent: true,
      with: "subCategory",
    },
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Name", field: "name" }, 
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "category",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          name: {
            data: item?.name,
            className: "",
            sticky: false,
            variant: "name",
          },
          subCategeory: {
            data: item.subCategory?.map((sub) => sub.name).join(", "),
            className: "",
            sticky: false,
            variant: "name",
          },
          description: {
            data: item.description,
            className: "",
            sticky: false,
            variant: "text",
          },
          createdAt: {
            data: item.created_at,
            className: "",
            sticky: false,
            variant: "date",
          },

          status: {
            data: item.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: customCases,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
          add: (item) => {
            setSelectedId(item);
            setIsSubCategoryModalOpen(item, actions_type.ADD);
          },
          delete: (item) => {
            handleDelete(item.uuid.data, deleteCategory, {
              successMessage: "Category deleted successfully!",
              errorMessage: "Failed to delete category!",
            });
          },
          view: (item) => {
            setIsEditValue(data);
            navigate(`/inventory/category/detail/${item.uuid.data}`);
          },
          edit: (item) => {
            openModal(item, actions_type.ADD_EDIT);
            const InitialData = {
              uuid: item.uuid.data,
              name: item?.name.data,
              description: item.description.data,
            };
            setIsEditValue(InitialData);
          },
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Sub Category",
      key: "subCategeory",
    },
    {
      label: "Description",
      key: "description",
    },
    {
      label: "Created At",
      key: "createdAt",
    },
  ];

  // Comprehensive form fields
  const categoryFields = [
    // Basic text fields
    {
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter category name",
      required: true,
      minLength: 2,
      maxLength: 40,
    },

    // Textarea
    {
      name: "description",
      label: "Description",
      type: "textarea",
      required: true,
      placeholder: "Write description here...",
      maxLength: 300,
    },
  ];

  const subCategoryFields = [
    // Basic text fields
    {
      name: "name",
      label: "Sub-Category Name",
      type: "text",
      placeholder: "Enter subcategory name",
      required: true,
      minLength: 2,
      maxLength: 40,
    },
  ];

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (isSubCategoryModalOpen) {
        const payload = {
          ...values,
          parent_id: selectedId?.id?.data,
        };

        await handleCreate(payload, createCategory, {
          successMessage: "Sub-category created successfully!",
          errorMessage: "Failed to create sub-category!",
        });
      } else if (isEditValue) {
        await handleUpdate(values, isEditValue.uuid, updateCategory, {
          successMessage: "Category updated successfully!",
          errorMessage: "Failed to update category!",
        });
      } else {
        await handleCreate(values, createCategory, {
          successMessage: "Category created successfully!",
          errorMessage: "Failed to create category!",
        });
      }
    } finally {
      setSubmitting(false);
      setIsSubCategoryModalOpen(false);
      setTimeout(() => {
        resetForm();
      }, 2000);
    }
  };

  // Handle form cancellation
  const handleCancel = () => {
    setIsEditValue(null);
    closeModal();
  };

  const onClose = (reload = false) => {
    setSelectedId("");
    setIsSubCategoryModalOpen(false);
    if (reload === true) {
      fetchData();
    }
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        shorting
        sortingModule="category"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />

        {action === actions_type.ADD_EDIT && (
          <CommonModal
            modalSize="lg"
            headerTitle={selectedId ? "Edit Category" : "Add Category"}
            onClose={handleCancel}
            show={action === actions_type.ADD_EDIT}
          >
            {/* Form */}
            <CommonForm
              fields={categoryFields}
              initialData={isEditValue ? isEditValue : {}}
              onSubmit={handleSubmit}
              submitButtonText={"Submit"}
              onCancel={handleCancel}
              cancelButtonText="Reset"
              columnsPerRow={1}
              gap="gap-4"
              rowClassName="   "
              fieldClassName="bg-white p-3 rounded shadow-sm"
            />
          </CommonModal>
        )}
        {
          <CommonModal
            modalSize="lg"
            headerTitle={
              selectedId ? selectedId?.name?.data : "Add Sub Category"
            }
            onClose={onClose}
            show={isSubCategoryModalOpen ? true : false}
          >
            <CommonForm 
              fields={subCategoryFields}
              initialData={isEditValue ? isEditValue : {}}
              onSubmit={handleSubmit}
              submitButtonText={"Submit"}
              onCancel={handleCancel}
              cancelButtonText="Cancel"
              columnsPerRow={1}
              gap="gap-4"
              rowClassName="   "
              fieldClassName="bg-white p-3 rounded shadow-sm"
            />

          </CommonModal>
        }
      </div>
    </div>
  );
};
export default ManageCategory;
